import {AsyncActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/AsyncActDecorator';
import {CoreSettingsParameters, Settings} from '@gongxigames/framework/core';
import {SlotSettingsParameters} from '@gongxigames/framework/slot';

export class LoadGameTextsAct extends AsyncActDecorator {
    public async execute(): Promise<void> {
        const languageService = this.languageService;
        const {regulationType, changeWinToPayout, freezeNewTextsUpdate} = (this.settings as Settings<SlotSettingsParameters & CoreSettingsParameters>).getAllProperties();
        const {lang} = await this.resourceManager.loadGameTexts();

        languageService.mergeTexts(lang.data);

        languageService.applyTextsOverride({
            regulationType,
            skin: this.environmentProperty.buildProperty.gameProperty.skinName,
            changeWinToPayout
        });

        if (freezeNewTextsUpdate) {
            languageService.overrideFreezedTexts();
        }
    }

    getName(): string {
        return 'LoadGameTextsAct';
    }
}